import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, capabilities, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-152" data-mp="ugxh5jwq0ua1">
        <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="fin1hk1e57in">
          <header className="text-center" data-id="element-154" data-mp="fjx14dnw6nre">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-155" data-mp="khyj0v9l0h1a">
              🏆 SISTEMA EQUILIBRIO EN CASA™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium" data-id="element-156" data-mp="3ldi1i5nb4s6k">
              Tu sistema en 4 volúmenes para identificar lo que necesitás, aplicar prácticas de bienestar y convertirlas en rutinas simples para tu día a día.
            </p>
          </header>
          
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-157" data-mp="3qf7e3pq6hdwr">
            📚 4 VOLÚMENES COMPLETOS
          </h3>
          <div className="mx-auto mt-7 max-w-3xl rounded-2xl border border-primary/30 bg-canvas p-5 sm:p-7" data-id="element-158" data-mp="32otkvvvux90l">
            <p className="text-center font-display text-base font-bold text-primary-soft sm:text-lg" data-id="element-159" data-mp="2xndzg2prp0ho">
              CON ESTE SISTEMA VAS A PODER:
            </p>
            <ul className="mt-4 grid gap-3 md:grid-cols-3" data-id="element-160" data-mp="36p3z1vtsz5qj">
              {capabilities.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-161" data-mp="2izsus4d8ut7n">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-162" data-mp="2ey7ncyjhb74u" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="mt-7 space-y-5" data-id="element-163" data-mp="mwo975ctf75j">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-164" data-mp="rqimnr1tupw6" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-165" data-mp="9018crhqrwuc" />
                  <div className="flex-1" data-id="element-166" data-mp="dueyaedmxbrm">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-167" data-mp="1kbs9uqky3s83">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-168" data-mp="1pe12fltwos9o">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm text-foreground-subtle sm:text-base" data-id="element-169" data-mp="34umbq23x0aov">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-170" data-mp="3022wz1thr9ih">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-171" data-mp="2v4jic0svsuq0">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-172" data-mp="2q3n5gxqjxy8g" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-173" data-mp="2h74psn7c06tt">
                      <span className="font-semibold text-foreground-subtle" data-id="element-174" data-mp="2c8jr4s7q9v7h">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-175" data-mp="fbklwhrggglw">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-176" data-mp="3885fk2pobuiv" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-177" data-mp="387dsxhe2174q">
        <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="2u8mflx70nphn">
          <header className="text-center" data-id="element-179" data-mp="2u7ujml9ibpqu">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-180" data-mp="2ub07jx6eglkz" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-181" data-mp="2z9tmzv58ymns">
              Y ADEMÁS, TE LLEVÁS 5 BONOS
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-182" data-mp="2pack1lhdqmvi">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-183" data-mp="2ggg0meflnojs">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-184" data-mp="21m1nguipv9d1">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-185" data-mp="1mxru759z5h9u">
                  <h3 className="font-bold" data-id="element-186" data-mp="1ivxylbemz3gj">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-187" data-mp="1ix969mb7cvcx">
                    {detail}
                  </p>
                  <ul className="mt-3 space-y-1.5" data-id="element-188" data-mp="1rwcnekqt70os">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-189" data-mp="1rv1lyrku650u">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-190" data-mp="25u1b00c9glxj" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-191" data-mp="2amuc8e8itc4v">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-192" data-mp="2anm8lr9xzdw7">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-193" data-mp="2pkmo8weuzieb">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-194" data-mp="2ro8a1hebm2d4">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-195" data-mp="31mnz7etsf1jz">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-196" data-mp="36dmm4x9a6xw7">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-197" data-mp="3bb615zdszep7">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-198" data-mp="3fbznwpfiengi">
              GRATIS con tu Sistema Equilibrio en Casa™
            </p>
          </div>
        </div>
      </section>
    </>;
}